import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AdminAuthService } from '../services/admin-auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminSessionGuard implements CanActivate {

  constructor(private router: Router, private adminAuthService: AdminAuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    // If already authenticated, redirect to dashboard
    if (this.adminAuthService.isAuthenticated()) {
      return this.router.createUrlTree(['/admin/dashboard']);
    }
    return true;
  }
}

